let livemode=true;
let baseUrl='';
let logoUrl ='';
let Flagurl ='';
let KYCurl ='';
let Assets ='';

if (livemode) {
    baseUrl='https://courierx-b2b.fniix.com/api/';
    logoUrl ='https://cdn-courier-x.fniix.com/Logo/';
    Flagurl = 'https://cdn-courier-x.fniix.com/Flag/';
    KYCurl = 'https://cdn-courier-x.fniix.com/KYC/';
    Assets ='https://cdn-courier-x.fniix.com/Assets/';
    
} else {
    baseUrl='http://192.168.29.207:8000/api/';
    logoUrl ='https://cdn-courier-x.fniix.com/Logo/';
    Flagurl = 'https://cdn-courier-x.fniix.com/Flag/';
    KYCurl = 'https://cdn-courier-x.fniix.com/KYC/';
    Assets ='https://cdn-courier-x.fniix.com/Assets/';
}
let Global={
    baseUrl:baseUrl,
    logoUrl:logoUrl,
    flagurl:Flagurl,
    kyc:KYCurl,
    timezone:'Asia/Kolkata',
    Assets:Assets
};
export default Global;